module.exports = __webpack_public_path__ + "img/logo.f7666a75.png";